import { gql } from 'graphql-tag';

export const getOrganisationCustomFieldSections = gql`
  query GetOrganisationCustomFieldSections {
    getOrganisationCustomFieldSections {
      sections {
        id
        name
        description
        isDefault
        displayOrder
        fieldCount
        fields {
          id
          label
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const createCustomFieldSection = gql`
  mutation CreateCustomFieldSection(
    $input: CreateCustomFieldSectionInputType!
  ) {
    createCustomFieldSection(input: $input) {
      id
      name
      description
      isDefault
      displayOrder
      fieldCount
      createdAt
      updatedAt
    }
  }
`;

export const updateCustomFieldSection = gql`
  mutation UpdateCustomFieldSection(
    $input: UpdateCustomFieldSectionInputType!
  ) {
    updateCustomFieldSection(input: $input) {
      id
      name
      description
      isDefault
      displayOrder
      fieldCount
      createdAt
      updatedAt
    }
  }
`;

export const deleteCustomFieldSection = gql`
  mutation DeleteCustomFieldSection(
    $input: DeleteCustomFieldSectionInputType!
  ) {
    deleteCustomFieldSection(input: $input) {
      id
      deleted
    }
  }
`;

export const reorderCustomFieldSections = gql`
  mutation ReorderCustomFieldSections(
    $input: ReorderCustomFieldSectionsInputType!
  ) {
    reorderCustomFieldSections(input: $input) {
      sections {
        id
        name
        description
        isDefault
        displayOrder
        fieldCount
        createdAt
        updatedAt
      }
    }
  }
`;
